import { Button, Card, CardContent } from '@predoc/cow';
import { PageHeader } from '@/components/PageHeader';
import { RequestDataDeletionModal } from './components/RequestDataDeletionModal';
import { useState } from 'react';
import { Separator } from '@predoc/cow';
import { Navigate } from 'react-router';
import { usePageTitle } from '@/hooks';
import { Permission, useHasPermission } from '@/utils/roles';
import { useGetOrganizationInfo } from '@/feature/profiles/hooks/organizationAPI';
import { PageLoading } from '@/components/PageLoading';

export const OrganizationSettingsPage = () => {
  usePageTitle('Organization Settings');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { hasPermission } = useHasPermission(Permission.SUBMIT_DATA_DELETION);
  const { data: organizationInfo, isLoading } = useGetOrganizationInfo();

  if (isLoading) {
    return <PageLoading />;
  }

  if (!organizationInfo?.enableDataDeletionRequests) {
    return <Navigate to="/" replace />;
  }

  const canSubmitDeletion = hasPermission;
  return (
    <div className="bg-muted min-h-screen">
      <PageHeader>
        <h1 className="text-3xl font-bold">Organization Settings</h1>
      </PageHeader>

      <div className="p-6">
        <Card className="p-0">
          <CardContent className="p-0">
            {canSubmitDeletion ? (
              <div className="p-10">
                <div className="flex items-start justify-between gap-8">
                  <div>
                    <h2 className="text-foreground text-lg font-semibold">
                      Request Patient Data Deletion
                    </h2>
                    <p className="text-foreground mt-1 text-sm">
                      Need to request the deletion of patient Protected Health
                      Information (PHI) and Personally Identifiable Information
                      (PII)? Start here.
                    </p>
                  </div>
                  <Button
                    variant="outline"
                    className="font-normal"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Request Data Deletion
                  </Button>
                </div>
              </div>
            ) : null}

            <Separator className="my-4 w-full" />

            <div className="py-8">
              <p className="text-foreground text-center text-sm">
                Need support? Email us at{' '}
                <a
                  href="mailto:support@predoc.ai"
                  className="text-foreground font-semibold underline"
                >
                  support@predoc.ai
                </a>
                .
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
      <RequestDataDeletionModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
      />
    </div>
  );
};
